import { render, staticRenderFns } from "./SalesReportQueryInputs.vue?vue&type=template&id=37d43f88&"
import script from "./SalesReportQueryInputs.vue?vue&type=script&lang=ts&"
export * from "./SalesReportQueryInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports